module.exports = __webpack_public_path__ + "static/media/interactive-video.43a99d28.svg";